<template>
  <div class="content-sections">
    <h1>Indholdssektioner</h1>
    <hr>
    <template v-if="loading">
      <b-skeleton animation="wave" width="50%" height="30px" class="mt-5 mb-3"></b-skeleton>
      <b-skeleton-img height="600px"></b-skeleton-img>
      <b-skeleton animation="wave" width="50%" height="30px" class="mt-5 mb-3"></b-skeleton>
      <b-skeleton-img height="600px"></b-skeleton-img>
      <b-skeleton animation="wave" width="50%" height="30px" class="mt-5 mb-3"></b-skeleton>
      <b-skeleton-img height="600px"></b-skeleton-img>
      <b-skeleton animation="wave" width="50%" height="30px" class="mt-5 mb-3"></b-skeleton>
      <b-skeleton-img height="200px"></b-skeleton-img>
    </template>
    <template v-else>
      <div class="d-flex mt-5 mb-2 justify-content-between align-items-center">
        <h2>{{front_page.name}}</h2>
        <b-overlay :show="savingFrontPage" variant="light" :opacity="0.5" spinner-variant="primary" spinner-small rounded="sm">
          <b-button variant="primary" @click="saveFrontPage()">Gem {{front_page.name}}</b-button>
        </b-overlay>
      </div>
      <b-overlay :show="savingFrontPage" variant="dark" :opacity="0.15" spinner-variant="primary">
        <editor
          id="front_page"
          apiKey="bvtv0k3l32ywgtrypzpkaf1lcxq8lhg4uj4jjez261xz21jj"
          initialValue=""
          v-model="front_page.content"
          :init="{
            height: 600,
            menubar: false,
            theme: 'silver',
            skin_url: '/oxide',
            invalid_elements: 'div',
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
              'visualblocks'
            ],
            toolbar:
              'undo redo visualblocks | formatselect | bold italic | \
              alignleft aligncenter alignright alignjustify | link | \
              bullist numlist outdent indent | help'
          }"
        ></editor>
      </b-overlay>
      <div class="d-flex mt-5 mb-2 justify-content-between align-items-center">
        <h2>{{about.name}}</h2>
        <b-overlay :show="savingAbout" variant="light" :opacity="0.5" spinner-variant="primary" spinner-small rounded="sm">
          <b-button variant="primary" @click="saveAbout()">Gem {{about.name}}</b-button>
        </b-overlay>
      </div>
      <b-overlay :show="savingAbout" variant="dark" :opacity="0.15" spinner-variant="primary">
        <editor
          id="about"
          apiKey="bvtv0k3l32ywgtrypzpkaf1lcxq8lhg4uj4jjez261xz21jj"
          initialValue=""
          v-model="about.content"
          :init="{
            height: 600,
            menubar: false,
            theme: 'silver',
            skin_url: '/oxide',
            invalid_elements: 'div',
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
              'visualblocks'
            ],
            toolbar:
              'undo redo visualblocks | formatselect | bold italic | \
              alignleft aligncenter alignright alignjustify | link | \
              bullist numlist outdent indent | help'
          }"
        ></editor>
      </b-overlay>
      
      <div class="d-flex mt-5 mb-2 justify-content-between align-items-center">
        <h2>{{consent.name}}</h2>
        <b-overlay :show="savingConsent" variant="light" :opacity="0.5" spinner-variant="primary" spinner-small rounded="sm">
          <b-button variant="primary" @click="saveConsent()">Gem {{consent.name}}</b-button>
        </b-overlay>
      </div>
      <b-overlay :show="savingConsent" variant="dark" :opacity="0.15" spinner-variant="primary">
        <editor
          id="consent"
          apiKey="bvtv0k3l32ywgtrypzpkaf1lcxq8lhg4uj4jjez261xz21jj"
          initialValue=""
          v-model="consent.content"
          :init="{
            height: 600,
            menubar: false,
            theme: 'silver',
            skin_url: '/oxide',
            invalid_elements: 'div',
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
              'visualblocks'
            ],
            toolbar:
              'undo redo visualblocks | formatselect | bold italic | \
              alignleft aligncenter alignright alignjustify | link | \
              bullist numlist outdent indent | help'
          }"
        ></editor>
      </b-overlay>

      <div class="d-flex mt-5 mb-2 justify-content-between align-items-center">
        <h2>{{footer.name}}</h2>
        <b-overlay :show="savingFooter" variant="light" :opacity="0.5" spinner-variant="primary" spinner-small rounded="sm">
          <b-button variant="primary" @click="saveFooter()">Gem {{footer.name}}</b-button>
        </b-overlay>
      </div>
      <b-overlay :show="savingFooter" variant="dark" :opacity="0.15" spinner-variant="primary">
        <editor
          id="footer"
          apiKey="bvtv0k3l32ywgtrypzpkaf1lcxq8lhg4uj4jjez261xz21jj"
          initialValue=""
          v-model="footer.content"
          :init="{
            height: 200,
            menubar: false,
            theme: 'silver',
            skin_url: '/oxide',
            invalid_elements: 'div',
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
              'visualblocks'
            ],
            toolbar:
              'undo redo visualblocks | formatselect | bold italic | \
              alignleft aligncenter alignright alignjustify | link | \
              bullist numlist outdent indent | help'
          }"
        ></editor>
      </b-overlay>
    </template>
    <b-alert
      style="max-width:800px; margin: 0 auto; left: 50%; transform: translateX(-50%); bottom:20px;"
      :show="dismissCountDown"
      dismissible
      fade
      variant="danger"
      class="fixed-bottom mx-4"
    >
      {{error}}
    </b-alert>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver/theme'
import 'tinymce/icons/default'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/link'
import 'tinymce/plugins/image'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/visualblocks'
import 'tinymce/plugins/code'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/print'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/media'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/code'
import 'tinymce/plugins/help'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/table'
import 'tinymce/plugins/visualblocks'
export default {
  components: {
    Editor
  },
  data: () => ({
    front_page: null,
    about: null,
    consent: null,
    footer: null,
    loading: true,
    error: '',
    savingFrontPage: false,
    savingAbout: false,
    savingConsent: false,
    savingFooter: false,
    dismissSecs: 5,
    dismissCountDown: 0,
  }),
  mounted() {
    this.getContent()
    tinymce.init({
      invalid_elements : 'div',
      allow_script_urls: true
    })
  },
  methods: {
    getContent() {
      let config = this.$store.getters.getConfig
      this.axios.get('/api/sections/', config).then((response) => {
        let data = response.data.results
        this.front_page = data.find(item => item.key === 'front_page')
        this.consent = data.find(item => item.key === 'consent')
        this.about = data.find(item => item.key === 'about')
        this.footer = data.find(item => item.key === 'footer')
      }).finally(() => {
        this.loading = false
      }).catch(error => {
        console.error(error)
        this.error = error
        this.showAlert()
        this.loading = false
      })
    },
    saveFrontPage() {
      this.savingFrontPage = true
      let config = this.$store.getters.getConfig
      this.axios.put('/api/sections/front_page/', this.front_page, config).then((response) => {
        this.front_page = response.data
        this.savingFrontPage = false
      }).catch(error => {
        console.error(error)
        this.error = error
        this.showAlert()
        this.savingFrontPage = false
      })
    },
    saveAbout() {
      this.savingAbout = true
      let config = this.$store.getters.getConfig
      this.axios.put('/api/sections/about/', this.about, config).then((response) => {
        this.about = response.data
        this.savingAbout = false
      }).catch(error => {
        console.error(error)
        this.error = error
        this.showAlert()
        this.savingAbout = false
      })
    },
    saveConsent() {
      this.savingConsent = true
      let config = this.$store.getters.getConfig
      this.axios.put('/api/sections/consent/', this.consent, config).then((response) => {
        this.consent = response.data
        this.savingConsent = false
      }).catch(error => {
        console.error(error)
        this.error = error
        this.showAlert()
        this.savingConsent = false
      })
    },
    saveFooter() {
      this.savingFooter = true
      let config = this.$store.getters.getConfig
      this.axios.put('/api/sections/footer/', this.footer, config).then((response) => {
        this.footer = response.data
        this.savingFooter = false
      }).catch(error => {
        console.error(error)
        this.error = error
        this.showAlert()
        this.savingFooter = false
      })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>

<style>

</style>